import React, { Component } from 'react'

import classes from './SetChief.scss'

import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import { withStyles } from '@material-ui/core/styles'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Checkbox from '@material-ui/core/Checkbox'
import IconButton from '@material-ui/core/IconButton'
import InputGroup from '../../../../../../components/UI/Forms/InputGroup/InputGroup'
import Button from '../../../../../../components/UI/Button/Button'
import { withTranslate } from 'react-redux-multilingual'
import { Close } from '@material-ui/icons'
class SetChief extends Component {
  state = {
    chief: [],
    position: [],
    selectAss: [],
    selectPosition: [],
    value_list_id: {
      label: this.props.translate('select') + this.props.translate('assessor'),
      value: '',
      configs: {
        clearDisabled: true,
        options: []
      }
    },
    chiefAdd: []
  }

  static getDerivedStateFromProps = (props, state) => {
    let updateState = {}

    if (state.chief.length === 0 && state.chiefAdd.length === 0) {
      let value = props.levelTable.position_group.map(item => {
        return { ...item, weight_percent: 0 }
      })
      let chief = [
        {
          case_id: 0,
          value: value
        }
      ]
      updateState = {
        ...updateState,
        chief: chief,
        chiefAdd: chief
      }
    }
    if (state.value_list_id.configs.options.length === 0) {
      let val = props.assessor_group.filter(
        item => item.weight_percent !== '' && item.weight_percent
      )

      let option = val.map(item => {
        return {
          key: item.value_list_id,
          value: item.value_list_id,
          label: item.value_list_name
        }
      })
      updateState = {
        ...updateState,
        value_list_id: {
          ...state.value_list_id,
          configs: {
            ...state.value_list_id.configs,
            type: 'text',
            placeholder: 'select ass',
            options: option
          }
        }
      }

      if (state.position.length === 0 || state.value_list_id.value !== '') {
        let value = props.levelTable.position_group.map(item => {
          return { ...item, weight_percent: 0 }
        })
        let chief = [
          {
            case_id: 0,
            value: value
          }
        ]
        let position = props.assessor_group.map(item => {
          if (item.weight_percent !== '') {
            return {
              ...item,
              level_position_group: chief
            }
          } else {
            return item
          }
        })

        updateState = {
          ...updateState,
          position: position
        }

        //////////update/////////////
        let checkup = state.selectPosition.filter(item => {
          return item === props.selectWeight
        })

        if (props.selected && checkup.length === 0) {
          let pooooo = position.map(item => {
            let sel = props.selectWeight.assessor_group_criteria.map(se => {
              if (item.value_list_id === se.assessor_group_id) {
                let all = se.level_position_group.map(level => {
                  let po = props.levelTable.position_group.map(posi => {
                    let leval = level.value.find(leValue => {
                      if (posi.position_group_id === leValue.action2_position_group_id) {
                        return {
                          ...posi,
                          weight_percent: parseInt(leValue.weight_percent) || 0
                        }
                      } else {
                        return null
                      }
                    })
                    if (leval) {
                      return { ...posi, weight_percent: parseInt(leval.weight_percent) || 0 }
                    } else {
                      return { ...posi, weight_percent: 0 }
                    }
                  })

                  return {
                    case_id: level.case_id,
                    value: po
                  }
                })
                return { ...se, level_position_group: all }
              } else {
                return { ...se, level_position_group: chief }
              }
            })

            sel = sel.find(dd => {
              return dd !== undefined && item.value_list_id === dd.assessor_group_id
            })
            if (sel) {
              return {
                ...item,
                level_position_group: sel.level_position_group
              }
            } else {
              return {
                ...item,
                level_position_group: chief
              }
            }
          })

          pooooo = pooooo.map(item => {
            let level_position_group = []
            let caseId = 0
            level_position_group = item.level_position_group.map(level => {
              caseId = caseId + 1
              return {
                ...level,
                case_id: caseId - 1
              }
            })
            return {
              ...item,
              level_position_group: level_position_group
            }
          })

          let selectPosition = state.selectPosition
          selectPosition.push(props.selectWeight)
          updateState = {
            ...updateState,
            selectPosition: selectPosition,
            position: pooooo
          }
        }
        //////////update/////////////

        if (props.positionCh.length !== 0) {
          let findWeight = props.positionCh.find(
            item =>
              item.level_group_id === props.selectWeight.level_group_id &&
              item.structure_id === props.selectWeight.structure_id
          )

          if (findWeight.assessor_group_criteria.length !== 0) {
            let ass = findWeight.assessor_group_criteria.filter(
              item => item.weight_percent !== '' && item.weight_percent
            )
            if (ass[0].assessor_group_id) {
              let newAs = []
              ass = props.levelTable.assessor.map(item => {
                ass.map(ass => {
                  if (item.value_list_id === ass.assessor_group_id) {
                    newAs.push({
                      ...item,
                      weight_percent: ass.weight_percent
                    })
                  }
                  return ass
                })
                return item
              })
              ass = newAs
              return updateState
            }
            updateState = {
              ...updateState,
              position: findWeight.assessor_group_criteria
            }
            let options = ass.map(item => {
              return {
                key: item.value_list_id || item.assessor_group_id,
                value: item.value_list_id || item.assessor_group_id,
                label: item.value_list_name
              }
            })
            if (state.chief.length === 0) {
              let value = props.levelTable.position_group.map(item => {
                return { ...item, weight_percent: 0 }
              })
              let chief = [
                {
                  case_id: 0,
                  value: value
                }
              ]
              updateState = {
                ...updateState,
                chief: chief
              }
            }

            updateState = {
              ...updateState,
              value_list_id: {
                ...state.value_list_id,
                configs: {
                  type: 'text',
                  placeholder: 'select ass',
                  options: options
                }
              }
            }
          }
        }
      }
    }

    if (state.value_list_id.value !== '' && state.value_list_id.value !== state.selectAss) {
      let cheif = state.position.find(item => item.value_list_id === state.value_list_id.value.key)

      props.finish(state.position)
      updateState = {
        ...updateState,
        selectAss: state.value_list_id.value,
        chief: cheif?.level_position_group
      }
    }

    return updateState
  }

  inputSelectChanged = (val, e) => {
    this.setState({
      value_list_id: {
        ...this.state.value_list_id,
        value: val
      }
    })
  }

  addCheif = e => {
    let chief = this.state.chief
    let value = this.props.levelTable.position_group.map(item => {
      return { ...item, weight_percent: 0 }
    })
    chief.push({
      case_id: chief.length,
      value: value
    })

    this.setState({
      chief: chief
    })

    let position = this.state.position.map(item => {
      if (item.weight_percent !== '' && item.value_list_id === this.state.value_list_id.value.key) {
        return {
          ...item,
          level_position_group: chief
        }
      } else {
        return item
      }
    })

    this.setState({
      position: position
    })
  }

  delChief = (e, row) => {
    let chief = this.state.chief
    chief = chief
      .filter(item => item !== row)
      .map((item, index) => {
        return {
          ...item,
          case_id: index
        }
      })
    this.setState({
      chief: chief
    })

    let position = this.state.position.map(item => {
      if (item.weight_percent !== '' && item.value_list_id === this.state.value_list_id.value.key) {
        return {
          ...item,
          level_position_group: chief
        }
      } else {
        return item
      }
    })
    this.props.finish(position)
    this.setState({
      position: position
    })
  }

  checkRow = () => {
    let check = this.props.levelTable.structure.find(
      item => item.structure_id === this.props.selectWeight.structure_id
    )
    return (
      check.structure_type.value_list_code === 'STT02' ||
      check.structure_type.value_list_code === 'STT06' ||
      check.structure_type.value_list_code === 'STT05'
    )
  }
  handleCheck = (col, row, e) => {
    let chief = this.state.chief.map(item => {
      if (item === row) {
        let val = item.value.map(po => {
          if (po === col) {
            return {
              ...po,
              weight_percent: col.weight_percent === 0 ? 1 : 0
            }
          } else {
            return po
          }
        })
        return {
          ...item,
          value: val
        }
      } else {
        return item
      }
    })
    let position = this.state.position.map(item => {
      if (item.weight_percent !== '' && item.value_list_id === this.state.value_list_id.value.key) {
        return {
          ...item,
          level_position_group: chief
        }
      } else {
        return item
      }
    })

    this.setState({
      chief: chief,
      position: position
    })

    this.props.finish(position)
  }
  inputChanged = (col, row, e) => {
    let chief = this.state.chief.map(item => {
      if (item === row) {
        let val = item.value.map(po => {
          if (po === col) {
            return {
              ...po,
              weight_percent: parseInt(e.target.value) || 0
            }
          } else {
            return po
          }
        })
        return {
          ...item,
          value: val
        }
      } else {
        return item
      }
    })
    let position = this.state.position.map(item => {
      if (item.weight_percent !== '' && item.value_list_id === this.state.value_list_id.value.key) {
        return {
          ...item,
          level_position_group: chief
        }
      } else {
        return item
      }
    })

    this.setState({
      chief: chief,
      position: position
    })

    this.props.finish(position)
    this.props.valid(this.checkValid())
  }

  checkValid = () => {
    let valid = true
    let ass = this.state.position.filter(
      item => parseInt(item.weight_percent) >= 0 || item.weight_percent === '.00'
    )
    let check = this.props.levelTable.structure.find(
      item => item.structure_id === this.props.selectWeight.structure_id
    )

    if (
      check.structure_type.value_list_code === 'STT02' ||
      check.structure_type.value_list_code === 'STT06' ||
      check.structure_type.value_list_code === 'STT05'
    ) {
      ass.map(item => {
        item.level_position_group.map(po => {
          let weight = 0
          po.value.map(val => {
            weight = parseInt(val.weight_percent) + weight
            return val
          })
          if (weight === 100 || weight === 0) {
            valid = valid && true
          } else {
            valid = valid && false
          }

          return po
        })
        return item
      })

      return !valid
    } else {
      return false
    }
  }

  render() {
    const StyledTableCell = withStyles(theme => ({
      head: {
        backgroundColor: '#3d6bb3',
        color: theme.palette.common.white
      },
      body: {
        fontSize: 14
      }
    }))(TableCell)

    let test = this.state.position.find(
      item => item.value_list_id === this.state.value_list_id.value.key
    )

    return (
      <div>
        <InputGroup
          inputType={'newselect'}
          label={this.state.value_list_id.label}
          configs={{ ...this.state.value_list_id.configs, clearDisabled: true }}
          changed={(val, e) => this.inputSelectChanged(val, e)}
          inputValue={this.state.value_list_id.value}
        />
        {this.state.value_list_id.value !== '' ? (
          <div>
            <TableContainer component={Paper}>
              <Table className={classes.table} aria-label='spanning table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align='left'></StyledTableCell>
                    <StyledTableCell
                      align='center'
                      colSpan={this.props.levelTable.position_group.length}>
                      {this.props.translate('positionGroup')}
                    </StyledTableCell>
                    <StyledTableCell align='left'></StyledTableCell>
                  </TableRow>

                  <TableRow>
                    <StyledTableCell align='left'>{this.props.translate('no')}</StyledTableCell>
                    {this.props.levelTable.position_group.map(item => (
                      <StyledTableCell align='center'>{item.position_group_name}</StyledTableCell>
                    ))}
                    <StyledTableCell align='left'></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {test?.level_position_group.map(row => (
                    <TableRow key={row.case_id}>
                      <TableCell className={classes.InputAss}>
                        {parseInt(row.case_id) + 1}
                      </TableCell>
                      {row.value.map(col => (
                        <TableCell align='center' className={classes.Col}>
                          {this.checkRow() ? (
                            <InputGroup
                              inputType={'input'}
                              changed={e => this.inputChanged(col, row, e)}
                              inputValue={col.weight_percent}
                              configs={{
                                inputProps: {
                                  style: { textAlign: 'right' }
                                }
                              }}
                            />
                          ) : (
                            <Checkbox
                              checked={col.weight_percent === 0 ? false : true}
                              onChange={e => this.handleCheck(col, row, e)}
                            />
                          )}
                        </TableCell>
                      ))}

                      <TableCell>
                        <IconButton onClick={e => this.delChief(e, row)} size='small'>
                          <Close />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Button clicked={e => this.addCheif(e)}>{this.props.translate('addCase')}</Button>
            {this.checkValid() ? (
              <div style={{ color: 'red' }}>
                {this.props.translate('totalWeightValidationHelperText')}
              </div>
            ) : null}
            {/* <div className={classes.Button}>
              <Button
                size="medium"
                variant="contained"
                disabled={this.checkValid()}
                clicked={e => this.props.Savee(this.state.position)}
                color="primary">
                Finish
              </Button>
            </div> */}
          </div>
        ) : null}
      </div>
    )
  }
}

export default withTranslate(SetChief)
